
















































































import { Component, Vue } from 'vue-property-decorator';

import DraggableWidget from '@/components/util/DraggableWidget.vue';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';

import { User } from 'oidc-client';
import {
  Workorder,
  QueryWorkOrdersRequest,
  WorkorderPagedCollectionApiResponse,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';
import { SortChangedEvent } from '@/models/SortChangedEvent';

@Component({
  components: {
    DraggableWidget,
    WorkOrderListView
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    settings: 'settings'
  })
})
export default class WorkOrderListWidget extends Vue {
  private currentPropertyId!: string;
  private currentUser!: User;
  private settings!: PerformoSettings;

  private mineTeamAll!: string;
  private statusQuery!: string;
  private sortColumn!: string;
  private sortDirection!: string;
  private skip!: number;
  private pagedOrders!: WorkorderPagedCollectionApiResponse;
  private queryUpdatedFromPagination = false;

  data() {
    return {
      mineTeamAll: undefined,
      statusQuery: undefined,
      sortColumn: undefined,
      sortDirection: undefined,
      skip: undefined,
      pagedOrders: undefined
    };
  }

  private doWorkOrderListWidget() {
    // blank
  }

  get mineTeamAllItems() {
    var items = [];

    items.push({ key: 'Mine', value: 'mine' });

    if (this.currentUser.profile.Trades) {
      var workerTrades = this.currentUser.profile.Trades;

      if (Array.isArray(workerTrades)) {
        workerTrades.forEach((element: string) => {
          items.push({ key: element, value: element });
        });
      } else {
        items.push({ key: workerTrades, value: workerTrades });
      }
    }

    if (this.currentUser.profile.candoq.indexOf('View Orders: All') >= 0) {
      items.push({ key: 'All', value: '' });
    }
    return items;
  }

  get currentStatusQuery() {
    return this.statusQuery;
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.sortColumn = sort.column;
    this.sortDirection = sort.direction === 1 ? 'ascend' : 'descend';
    // should this be persisted across views?
    // window.localStorage.setItem('homeOrderSortColumn', this.sortColumn);
    // window.localStorage.setItem('homeOrderSortDirection', this.sortDirection);
  }

  private paginationSkipUpdatedHandler(skip: number) {
    this.skip = skip;
    this.queryUpdatedFromPagination = true;
  }

  private ordersUpdatedHandler(
    pagedOrders: WorkorderPagedCollectionApiResponse
  ) {
    this.pagedOrders = pagedOrders;
  }

  get currentQuery(): QueryWorkOrdersRequest {
    const query: QueryWorkOrdersRequest = {
      propertyId: this.currentPropertyId
    };

    if (this.sortColumn) {
      query.sortColumn = this.sortColumn;
      window.localStorage.setItem(
        'homeSortColumn',
        query.sortColumn.toString()
      );
    }
    if (this.sortDirection) {
      query.sortDirection = this.sortDirection;
      window.localStorage.setItem(
        'homeSortDirection',
        query.sortDirection.toString()
      );
    }
    if (this.skip) {
      if (this.queryUpdatedFromPagination) {
        query.skip = this.skip;
        this.queryUpdatedFromPagination = false;
      } else {
        query.skip = 1;
      }
    }

    if (this.currentStatusQuery) {
      query.orderStatus = this.currentStatusQuery;
      window.localStorage.setItem(
        'homeStatusQuery',
        query.orderStatus.toString()
      );
      if (query.orderStatus === 'All') {
        query.orderStatus = undefined;
      }
      if (
        query.orderStatus === 'Open' &&
        this.settings.openSubStatuses &&
        this.settings.openSubStatuses.length
      ) {
        query.includeSubStatuses = true;
      }
      if (
        query.orderStatus === 'Complete' &&
        this.settings.completeSubStatuses &&
        this.settings.completeSubStatuses.length
      ) {
        query.includeSubStatuses = true;
      }
    }

    if (this.mineTeamAll === 'mine') {
      query.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      query.trade = this.mineTeamAll;
    }

    if (this.mineTeamAll || this.mineTeamAll === '') {
      window.localStorage.setItem(
        'homeMineTeamAll',
        this.mineTeamAll.toString()
      );
    }

    return query;
  }

  created() {
    // need to load these in before the component is mounted
    this.statusQuery = window.localStorage.getItem('homeStatusQuery') ?? 'Open';
    this.sortColumn =
      window.localStorage.getItem('homeSortColumn') ?? 'orderNumber';
    this.sortDirection =
      window.localStorage.getItem('homeSortDirection') ?? 'descend';
    const mta = window.localStorage.getItem('homeMineTeamAll');
    var workerTrades = this.currentUser.profile.Trades;
    if (mta && workerTrades && workerTrades.includes(mta)) {
      this.mineTeamAll = mta;
    } else if (
      mta == '' &&
      this.currentUser.profile.candoq.indexOf('View Orders: All') >= 0
    ) {
      // ensure user has view all access before adding it
      this.mineTeamAll = '';
    } else {
      this.mineTeamAll = 'mine';
    }
  }

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }
}
